import { render } from "./EditPromoCategory.vue?vue&type=template&id=c71ca0ec&scoped=true&ts=true"
import script from "./EditPromoCategory.vue?vue&type=script&lang=ts"
export * from "./EditPromoCategory.vue?vue&type=script&lang=ts"

import "./EditPromoCategory.vue?vue&type=style&index=0&id=c71ca0ec&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c71ca0ec"]])

export default __exports__